<script lang="ts">
  import clickoutside from "./actions/clickoutside";
  import type { Bookmark } from "./bookmarks";
  import Bookmarks from "./Bookmarks.svelte";
  import ArrowLeft from "./icons/ArrowLeft.svelte";
  import ArrowRight from "./icons/ArrowRight.svelte";
  import ArrowUp from "./icons/ArrowUp.svelte";
  import Star from "./icons/Star.svelte";
  import type { PaneNav } from "./nav-history";
  import { tooltip } from "./Tooltip.svelte";

  // The row above a file list, and above the Home View, which has no folder
  // to bookmark and nowhere to go up to.
  interface Props {
    path?: string;
    currBookmark?: Bookmark;
    addtobookmarks?: () => void;
    // without it the up arrow is disabled
    fmdirup?: () => void;
    // going back and forward in the places of the pane. Each is there only
    // when there is a place to go to.
    nav?: PaneNav;
    gotobookmark: (b: Bookmark) => void;
  }

  let { path = "", currBookmark, addtobookmarks, fmdirup, nav, gotobookmark }: Props = $props();

  let showBookmarks = $state(false);
</script>

<div class="grow-0 flex items-center px-1 pl-2 py-1 bg-gray-300">
  <!-- bookmarks -->
  <div class="relative flex" use:clickoutside onclickoutside={() => (showBookmarks = false)}>
    <button onclick={() => (showBookmarks = !showBookmarks)} use:tooltip={"Bookmarks"}>
      <Star class="text-gray-700 hover:bg-gray-200 cursor-pointer" />
    </button>
    {#if showBookmarks}
      <Bookmarks {currBookmark} dismiss={() => (showBookmarks = false)} {gotobookmark} {addtobookmarks} />
    {/if}
  </div>

  <!-- left (back) -->
  {#if nav?.goback}
    <button onclick={nav.goback} use:tooltip={"back (Alt + Left)"} class="ml-2">
      <ArrowLeft class="text-gray-700 hover:bg-gray-200 cursor-pointer" />
    </button>
  {:else}
    <button disabled class="ml-2">
      <ArrowLeft class="text-gray-400" />
    </button>
  {/if}

  <!-- right (forward) -->
  {#if nav?.goforward}
    <button onclick={nav.goforward} use:tooltip={"forward (Alt + Right)"} class="ml-2">
      <ArrowRight class="text-gray-700 hover:bg-gray-200 cursor-pointer" />
    </button>
  {:else}
    <button disabled class="ml-2">
      <ArrowRight class="text-gray-400" />
    </button>
  {/if}

  <!-- up  -->
  {#if fmdirup}
    <button onclick={() => fmdirup()} use:tooltip={"go up"} class="ml-2">
      <ArrowUp class="text-gray-700 hover:bg-gray-200 cursor-pointer" />
    </button>
  {:else}
    <button disabled class="ml-2">
      <ArrowUp class="text-gray-400" />
    </button>
  {/if}

  <div class="ml-2 grow px-2 py-1 bg-gray-50 text-xs truncate">{path}</div>
</div>
